import { normalizeReferenceNumber } from '../orderMatching/normalizeReferenceNumber'

export function normalizePurchaseOrderText(value: string): string {
  return value.normalize('NFKC').trim().toUpperCase().replace(/\s+/g, ' ')
}

export function normalizePurchaseOrderProjectName(value: string): string {
  return normalizePurchaseOrderText(normalizePurchaseOrderText(value).replace(/\(仮称\)/g, ''))
}

export function normalizePurchaseOrderSupplierName(value: string): string {
  return normalizePurchaseOrderText(normalizePurchaseOrderText(value).replace(/株式会社|有限会社|\(株\)|\(有\)/g, ''))
}

export function normalizePurchaseOrderNumber(value: string): string {
  return normalizeReferenceNumber(value.normalize('NFKC')).replace(/^(?:NO\.|NO(?=\s*\d)|#)\s*/, '')
}

export function normalizePurchaseOrderSteelType(value: string): string {
  return normalizePurchaseOrderText(value)
}

export function normalizePurchaseOrderSize(value: string): string {
  return (
    normalizePurchaseOrderText(value)
      // 「（両端十字スリット加工）」のような加工注記は寸法ではなく、残すと MS 側の寸法と一致しない。
      .replace(/\([^)]*\)/g, '')
      .replace(/\s/g, '')
      .replace(/^(?:BH|FB|PL|H|L|P|□|○)-/, '')
      .replace(/[×*]/g, 'X')
      .replace(/(\d+)\.0+(?=X|$)/g, '$1')
  )
}

export function normalizePurchaseOrderLength(value: string | number): number | null {
  if (typeof value === 'number') {
    return Number.isSafeInteger(value) && value > 0 ? value : null
  }
  const normalized = normalizePurchaseOrderText(value).replace(/,/g, '')
  if (!/^\d+(?:\.\d+)?(?:\s*MM|\s*M)?$/.test(normalized)) {
    return null
  }
  const number = Number(normalized.replace(/\s*M{1,2}$/, ''))
  // 単位なしの小数表記は、正本の「12.0 = 12m」に合わせる。
  const meters = /(?<!M)M$/.test(normalized) || (!normalized.endsWith('MM') && normalized.includes('.'))
  const result = Math.round(number * (meters ? 1000 : 1))
  return Number.isSafeInteger(result) && result > 0 ? result : null
}

const sectionAliases: Record<string, string> = {
  H: 'H',
  H形鋼: 'H',
  外法H形鋼: 'H',
  BH: 'BH',
  PL: 'PL',
  鋼板: 'PL',
  FB: 'FB',
  平鋼: 'FB',
  L: 'L',
  山形鋼: 'L',
  P: 'P',
  鋼管: 'P',
  丸鋼管: 'P',
  '○': 'P',
  '□': '□',
  角形鋼管: '□',
  角型鋼管: '□',
}

export function normalizePurchaseOrderSectionType(value: string): string {
  const normalized = normalizePurchaseOrderText(value)
  return sectionAliases[normalized] ?? normalized
}
